import React from "react";
import SystemLabel from "../system/SystemLabel/SystemLabel";

export const formatTime = (date, lang = null, onlyToday = false) => {
  const isSameDay = datesAreOnSameDay(new Date(date), new Date());
  
  if (isSameDay) {
    let formattedDate = new Date(date);
    let h = formattedDate.getHours();
    let m = formattedDate.getMinutes();
    if (m < 10) m = "0" + m;
    if (h < 10) h = "0" + h;
    return h + ":" + m;
  } else {
    let formattedDate = new Date(date);
    let d = formattedDate.getUTCDay().toString().substr(0, 3);
    let h = formattedDate.getHours();
    let m = formattedDate.getMinutes();
    if (m < 10) m = "0" + m;
    if (h < 10) h = "0" + h;
    return (
      <React.Fragment>
        <span style={{ marginRight: 0 }}>{dayConverter(d, lang)}</span>{" "}
        {" " + h + ":" + m}
      </React.Fragment>
    );
  }
};

export const isTheSameMinute = (d1, d2) => {
  const date1 = new Date(d1);
  const date2 = new Date(d2);
  if (
    date1.getDate() == date2.getDate() &&
    date1.getDay() == date2.getDay() &&
    date1.getHours() == date2.getHours() &&
    date1.getMinutes() == date2.getMinutes()
  ) {
    return true;
  }
  return false;
};
const dayConverter = (d, lang) => {
  switch (d) {
    case "1":
      return <SystemLabel name="Monday" languageCode={lang} />;
    case "2":
      return <SystemLabel name="Tuesday" languageCode={lang} />;
    case "3":
      return <SystemLabel name="Wednesday" languageCode={lang} />;
    case "4":
      return <SystemLabel name="Thursday" languageCode={lang} />;
    case "5":
      return <SystemLabel name="Friday" languageCode={lang} />;
    case "6":
      return <SystemLabel name="Saturday" languageCode={lang} />;
    case "7":
      return <SystemLabel name="Sunday" languageCode={lang} />;
    default:
      return "";
  }
};
export const datesAreOnSameDay = (first, second) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate();
